import type { AdminSupplierSettings } from '@repo/api-contracts';
import { trpc } from '@/shared/api';
export const useInvalidateSupplierSettings = () => {
  const utils = trpc.useUtils();
  return {
    setData: (data: AdminSupplierSettings) => utils.supplierSettings.get.setData(undefined, data),
    invalidate: () => utils.supplierSettings.get.invalidate(),
  };
};
